<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="6" :lg="6">
          <el-input placeholder="邀请人手机号" v-model="invite_mobile" clearable @clear="numberSearch" @keyup.enter.native="numberSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选合伙人’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-table :data="shenqingData" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
<!--        <el-table-column prop="id" label="ID" width="95"></el-table-column>-->
        <el-table-column prop="user_id" label="怡贝会员ID" width="130"></el-table-column>
        <el-table-column prop="name" label="真实姓名" width="130"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" width="130"></el-table-column>
        <el-table-column prop="sex" label="性别" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.sex=='2'">女</span>
            <span v-else-if="scope.row.sex=='1'">男</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="invite_user_id" label="邀请人ID" width="130"></el-table-column>
        <el-table-column prop="invite_mobile" label="邀请人手机号" width="130"></el-table-column>
        <el-table-column prop="description" label="审核说明" width="130"></el-table-column>
        <el-table-column prop="created_date" label="申请时间" width="190"></el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getHhmemberList, hhmemberExport} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      total_count: 0,
      loading: false,
      exportLoading: false,
      shenqingData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      invite_mobile: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getItems (filter) {
      this.loading = true
      getHhmemberList(filter).then(response => {
        this.shenqingData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        this.exportLoading = false
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getItems(this.params)
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    getParams () {
      this.params.invite_mobile = this.invite_mobile
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getItems(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    numberSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getItems(this.params)
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      hhmemberExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选合伙人中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  mounted () {
    this.getItems(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
    shenqingData: {
      handler (value) {
        if (this.allCheck) {
          this.shenqingData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// shenqing_list.vue?c679c05a